<svg
  width="96"
  height="96"
  viewBox="0 0 96 96"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M49.1782 67.8565C48.4532 59.9678 49.6028 49.3359 54.253 44.1848C59.1503 45.2707 68.9449 41.9196 72.5066 35.1235C75.7363 28.9608 75.1509 19.917 76.9587 17.4545C55.6625 17.4544 52.1292 39.4679 46.0308 55.9534C41.5218 43.7641 27.3709 35.5504 15.0744 40.5605C20.0736 44.0162 23.1907 52.5376 29.9643 53.3002C32.0954 53.5402 35.9657 53.3002 38.5148 48.4826C44.5468 53.3824 43.6676 59.3243 42.8835 67.8565C42.567 71.3001 41.3756 74.5752 41.5506 77.3071C41.8018 82.1318 50.2599 82.1318 50.511 77.3071C50.6861 74.5752 49.4947 71.3001 49.1782 67.8565Z"
    fill="black"
  />
</svg>
